"use strict";

exports.__esModule = true;
exports.getOptionValue = getOptionValue;
exports.setOptionValue = setOptionValue;
var OPTIONS = {
  WorkInstructionTriggerDelay: {
    description: "The delay between trigger actions in the work instruction panel.",
    value: 20000
  }
};

/**
 * Get the value of the given option.
 * @throws {Error} if the option does not exist.
 */
function getOptionValue(optionName) {
  var option = OPTIONS[optionName];
  if (option === undefined) {
    throw new Error("No such option: " + optionName);
  }
  return option.value;
}

/**
 * Set the value of an individual option.
 * @throws {Error} if the option does not exist.
 */
function setOptionValue(optionName, value) {
  var option = OPTIONS[optionName];
  if (option === undefined) {
    throw new Error("No such option: " + optionName);
  }
  option.value = value;
}